import { Core, Decorative } from "@faire/design-tokens";
import { MarketStore } from "@faire/retailer-visitor-shared/stores/domain/Events/FaireMarkets/MarketStore";
import { eventsThemeColors } from "@faire/web--source/slate/Theme/eventsThemeColors";
export var DEFAULT_BRAND_TILE_PROMO_STYLE = {
    lightBackground: Core.surface.inverse,
    promoText: Decorative.shade.orange
};
export var getPromoBannerStyle = function(isHighlightedForPromotionalEvent) {
    if (isHighlightedForPromotionalEvent && (MarketStore.get().isLive || MarketStore.get().showAllSpecials)) {
        return eventsThemeColors.faireMarket;
    }
    return DEFAULT_BRAND_TILE_PROMO_STYLE;
};
